/*
 * Preorder marker. A roll variant that the store only sells past zero stock
 * carries preorder: true in window.VELVEN_MATERIALS (snippets/vmcm-size-json, the
 * one stock-state rule). Every cart add passes through VelvenCartEvents.add,
 * which calls annotate() so the line item property is written once, here, and
 * checkout, the order, the packing slip and the confirmation email all print it.
 * Samples and in-stock rolls are never marked.
 */
(function (global) {
  "use strict";

  if (global.VelvenPreorder) return;

  function copy() {
    var c = global.VELVEN_PREORDER || {};
    return { key: c.key || "Preorder", note: c.note || "Ships in about 8 weeks" };
  }

  function sizeFor(variantId) {
    var id = parseInt(variantId, 10);
    if (!id) return null;
    var list = global.VELVEN_MATERIALS || [];
    for (var i = 0; i < list.length; i++) {
      var sizes = list[i] && list[i].sizes;
      if (!sizes) continue;
      for (var key in sizes) {
        if (Object.prototype.hasOwnProperty.call(sizes, key) && sizes[key] && sizes[key].id === id) {
          return { key: key, size: sizes[key] };
        }
      }
    }
    return null;
  }

  // A4 samples are never preorderable, even if their size entry were mis-marked.
  function isPreorder(variantId) {
    var hit = sizeFor(variantId);
    return !!(hit && hit.key !== "a4" && hit.size.preorder === true);
  }

  function annotate(items) {
    var c = copy();
    (items || []).forEach(function (item) {
      if (!item || !isPreorder(item.id)) return;
      var props = {};
      var existing = item.properties || {};
      for (var k in existing) if (Object.prototype.hasOwnProperty.call(existing, k)) props[k] = existing[k];
      props[c.key] = c.note;
      item.properties = props;
    });
    return items;
  }

  global.VelvenPreorder = { annotate: annotate, isPreorder: isPreorder, copy: copy };
})(window);
